// A patient id is a backend Long. Route-derived ids can be malformed — a missing
// value interpolated into a path ("/patients/undefined/..."), or a raw route
// template navigated to verbatim ("/patients/:patientId/..."). Guarding on
// "truthy" isn't enough: the strings "undefined", "null" and ":patientId" are all
// truthy and would reach GET /patient/get/{id}, which 500s ("cannot convert to
// Long"). Only a run of digits is a real id.
export const isValidPatientId = (id) => /^\d+$/.test(String(id ?? "").trim());
